const ConditionalRender = ({ 
    condition, 
    children, 
    fallback = null, 
    truthyContent = null, 
    falsyContent = null 
}) => {
    // If truthyContent and falsyContent are provided, use ternary logic
    if (truthyContent !== null || falsyContent !== null) {
        return condition ? (truthyContent || children) : (falsyContent || fallback);
    }
    
    // Otherwise, use simple boolean logic (condition && children)
    return condition ? children : fallback;
}

export default ConditionalRender